<template>
  <div>
<!-- 最上方的检索框 -->
    <div class="title-related">
      <div class="related-container">
        <div class="related-words" v-if="!searchActive">Enter key words :</div>
        <div class="related-words" v-if="searchActive">Enter key words :</div>
        <div
          style="display: flex; width: 600px"
          v-if="!searchActive"
          @click="changeActive"
        >
          <!-- <div class="related-words-number">77</div> -->
          <div class="related-words-total">apt</div>
        </div>
        <div
          style="display: flex; width: 600px"
          v-if="searchActive"
          @click="changeActive"
        >
          <div class="search">
            <el-input
              v-model="input"
              placeholder="Search for..."
              clearable
              ref="inputRef"
              @keyup.enter.native="search"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </div>
        </div>
        <svg
          t="1730869271563"
          class="related-icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9032"
          width="30"
          height="30"
        >
          <path
            d="M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3 0.8 2.8 1.3 4.3 1.3s3-0.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39z m563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488z"
            fill="#000000"
            fill-opacity=".85"
            p-id="9033"
          ></path>
          <path
            d="M396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z m223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z m416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0.1-4.1-3.1-7.5-7-7.5z"
            fill="#216DCD"
            p-id="9034"
          ></path>
        </svg>
      </div>
    </div>
<!-- 中间水平轮播文献 -->
    <div class="paper-list">
      <el-carousel trigger="click" height="450px" :interval="6000" arrow="always">
        <el-carousel-item v-for="(paper, index) in papers.slice(0, 4)" :key="index">
          <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; padding: 15px 20px; box-sizing: border-box;">
            <el-card class="horizontal-card" style="width: 100%; max-height: 100%; overflow-y: auto;">
            <el-row type="flex" justify="start" align="middle" style="height: 100%;">
              <el-col :span="7">
                <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
                  <el-carousel
                    trigger="click"
                    height="300px"
                    arrow="always"
                    style="width: 100%"
                    indicator-position="outside"
                    :autoplay="false"
                  >
                    <el-carousel-item
                      v-for="item in paper.images"
                      :key="item"
                    >
                      <el-image
                        :src="item"
                        style="width: 330px; height: 300px"
                        alt="Image not found..."
                        :title="item"
                        fit="contain"
                      ></el-image>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="info" style="padding: 0 30px;">
                  <h3 v-html="paper.title"></h3>
                  <el-link
                    type="primary"
                    :href="paper.url"
                    target="_blank"
                  >{{ paper.url }}</el-link>
                  <p class="paper-author" v-html="paper.author"></p>
                  
                  <template v-if="paper.graphical_abstract">
                    <h4>Graphical Abstract</h4>
                    <p class="paper-abstract" v-html="paper.graphical_abstract"></p>
                  </template>
                  
                  <template v-else-if="paper.abstract">
                    <h4>Abstract</h4>
                    <p class="paper-abstract" v-html="paper.abstract"></p>
                  </template>
                  
                  <template v-else-if="paper.summary">
                    <h4>Summary</h4>
                    <p class="paper-abstract" v-html="paper.summary"></p>
                  </template>
                </div>
              </el-col>
            </el-row>
          </el-card>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
<!-- 最下方垂直轮播文献 -->
    <el-card shadow="always" style="width: 1300px; margin: 20px auto 50px auto; border-radius: 20px; border: none; box-sizing: border-box;">
      <h2 style="margin: 0 0 20px 0;">Recent Papers:</h2>
      <div class="recent-list" style="width: 100%; margin: 0;">
        <div style="height: 330px; overflow: hidden; width: 100%; box-sizing: border-box;">
          <ul :class="{ 'anim': animate }" style="margin: 0; padding: 0; list-style: none;" @mouseenter="stopScroll" @mouseleave="startScroll">
            <li v-for="(item, index) of publicationList" :key="index" style="height: 60px;">
              <div class="recent-item" style="height: 50px; box-sizing: border-box; margin: 5px 10px;">
                <div class="recent-content" style="display: flex; justify-content: space-between; align-items: center; height: 100%;">
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ item.title }}</span>
                  <span class="time">{{ item.year }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div style="width: 100%; text-align: right;" v-show="false">
          <el-button class="more-button" @click="goToMorePage">More</el-button>
        </div>
      </div>
    </el-card>
    </div>
</template>
  <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "PublicationHome",
  components: {  },
  data() {
    // return {
    //   papers: [
    //     {
    //       id: 0,
    //       title:
    //         "PMAT2: An efficient graphical assembly toolkit for comprehensive organellar genomes",
    //       author:
    //         "Fuchuan Han, Changwei Bi, Yicun Chen, Xiaogang Dai, Zefu Wang, Huaitong Wu, Ning Sun, Yanshu Qu, Yang Yang, Yangdong Wang, Tongming Yin",
    //       abstract:
    //         "We developed PMAT2, an advanced toolkit for lineage-specific de novo assembly of plant, animal, and fungal mitochondrial genomes, as well as plant chloroplast genome. PMAT2 leverages optimized graph-based strategies tailored to organelle genome complexity, enabling complete and accurate assemblies, even with approximately 1 × highly accurate PacBio high-fidelity (HiFi) reads. By assembling 150 organellar genomes across diverse lineages, PMAT2 outperformed existing tools in assembly completeness. The source code for PMAT2 is publicly available at https://github.com/aiPGAB/PMAT2.",
    //       images: [
    //         require("../images/article0/PMAT2_1.jpg"),
    //         require("../images/article0/PMAT2_2.jpg"),
    //         require("../images/article0/PMAT2_3.jpg"),
    //       ],
    //       url: "https://onlinelibrary.wiley.com/doi/10.1002/imt2.70064",
    //     },
    //     {
    //       id: 1,
    //       title:
    //         "PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data",
    //       author:
    //         "Bi, CW (Bi, Changwei) [1] , [2] ; Shen, F (Shen, Fei) [3] ; Han, FC (Han, Fuchuan) [4] ; Qu, YS (Qu, Yanshu) [1] ; Hou, J (Hou, Jing) [1] ; Xu, KW (Xu, Kewang) [1] ; Xu, LA (Xu, Li-an) [1] ; He, WC (He, Wenchuang) [5] ; Wu, ZQ (Wu, Zhiqiang) [5] ; Yin, TM (Yin, Tongming) [1]",
    //       abstract:
    //         "Complete mitochondrial genomes (mitogenomes) of plants are valuable resources for nucleocytoplasmic interactions, plant evolution, and plant cytoplasmic male sterile line breeding. However, the complete assembly of plant mitogenomes is challenging due to frequent recombination events and horizontal gene transfers. Previous studies have adopted Illumina, PacBio, and Nanopore sequencing data to assemble plant mitogenomes, but the poor assembly completeness, low sequencing accuracy, and high cost limit the sampling capacity. Here, we present an efficient assembly toolkit (PMAT) for de novo assembly of plant mitogenomes using low-coverage HiFi sequencing data. PMAT has been applied to the de novo assembly of 13 broadly representative plant mitogenomes, outperforming existing organelle genome assemblers in terms of assembly accuracy and completeness. By evaluating the assembly of plant mitogenomes from different sequencing data, it was confirmed that PMAT only requires 1× HiFi sequencing data to obtain a complete plant mitogenome. The source code for PMAT is available at https://github.com/bichangwei/PMAT. The developed PMAT toolkit will indeed accelerate the understanding of evolutionary variation and breeding application of plant mitogenomes.",
    //       images: [
    //         require("../images/article1/PMAT1.jpg"),
    //         require("../images/article1/PMAT2.jpg"),
    //         require("../images/article1/PMAT3.jpg"),
    //         require("../images/article1/PMAT4.jpg"),
    //       ],
    //       url: "https://doi.org/10.1093/hr/uhae023",
    //     },
    //     {
    //       id: 2,
    //       title:
    //         "The first mitogenome of Lauraceae (<i>Cinnamomum chekiangense</i>)",
    //       author:
    //         "Bi, CW (Bi, Changwei) [1] , [2] ; Sun, N (Sun, Ning) [2] ; Han, FC (Han, Fuchuan) [3] ; Xu, KW (Xu, Kewang) [4] ; Yang, Y (Yang, Yong) [4] ; Ferguson, DK (Ferguson, David K.) [5]",
    //       highlights:
    //         "<p>1. The first reported mitochondrial genome (<i>Cinnamomum chekiangense</i>) of the Lauraceae family.</p><p>2. The mitogenome of <i>C. chekiangense</i> retains almost all of the ancestral protein-coding genes and has the highest RNA editing number in angiosperms.</p><p>3. Both of the plastid and mitochondrial phylogenetic trees support the magnoliids as a sister group of monocots and eudicots.</p>",
    //       images: [
    //         require("../images/article2/image1.jpg"),
    //         require("../images/article2/image2.jpg"),
    //       ],
    //       url: "https://doi.org/10.1016/j.pld.2023.11.001",
    //     },
    //     {
    //       id: 3,
    //       title:
    //         "Deciphering the Multi-Chromosomal Mitochondrial Genome of <i>Populus simonii</i>",
    //       author:
    //         "Bi, CW (Bi, Changwei) [1] , [2] ; Qu, YS (Qu, Yanshu) [1] ; Hou, J (Hou, Jing) [1] ; Wu, K (Wu, Kai) [1] ; Ye, N (Ye, Ning) [2] ; Yin, TM (Yin, Tongming) [1]",
    //       abstract:
    //         "Mitochondria, inherited maternally, are energy metabolism organelles that generate most of the chemical energy needed to power cellular various biochemical reactions. Deciphering mitochondrial genome (mitogenome) is important for elucidating vital activities of species. The complete chloroplast (cp) and nuclear genome sequences of <i>Populus simonii</i> (<i>P. simonii</i>) have been reported, but there has been little progress in its mitogenome. Here, we assemble the complete <i>P. simonii</i> mitogenome into three circular-mapping molecules (lengths 312.5, 283, and 186 kb) with the total length of 781.5 kb. All three molecules of the <i>P. simonii</i> mitogenome had protein-coding capability. Whole-genome alignment analyses of four <i>Populus</i> species revealed the fission of poplar mitogenome in P. simonii. Comparative repeat analyses of four <i>Populus</i> mitogenomes showed that there were no repeats longer than 350 bp in <i>Populus</i> mitogenomes, contributing to the stability of genome sizes and gene contents in the genus <i>Populus</i>. As the first reported multi-circular mitogenome in <i>Populus</i>, this study of <i>P. simonii</i> mitogenome are imperative for better elucidating their biological functions, replication and recombination mechanisms, and their unique evolutionary trajectories in <i>Populus</i>.",
    //       images: [
    //         require("../images/article3/image1.jpg"),
    //         require("../images/article3/image2.jpg"),
    //         require("../images/article3/image3.jpg"),
    //         require("../images/article3/image4.jpg"),
    //         require("../images/article3/image5.jpg"),
    //       ],
    //       url: "https://doi.org/10.1093/hr/uhae023",
    //     },
    //     // 可以继续添加更多的论文信息
    //   ],
      return {
        papers: [
          // {
          //   id: 0,
          //   title:
          //     "Assembly of the complete mitochondrial genome of an endemic plant, <em>Scutellaria tsinyunensis</em>, revealed the existence of two conformations generated by a repeat-mediated recombination",
          //   author:
          //     "Jingling Li, Yicen Xu, Yuanyu Shan, Xiaoying Pei, Shunyuan Yong, Chang Liu & Jie Yu",
          //   abstract:
          //     "<em>Scutellaria tsinyunensis</em> belongs to the family Lamiaceae, distributed only in the Jinyun Mountain, Chongqing, China. As a valuable endemic and small population species, it is regarded as a natural resource potentially with significant economic and ecological importance. In this study, we assembled a complete and gap-free mitochondrial genome of <em>S. tsinyunensis</em>. This genome had a length of 354,073 bp and the base composition of the genome was A (27.44%), T (27.30%), C(22.58%), and G (22.68%). This genome encodes 59 genes, including 32 protein-coding genes, 24 tRNA genes, and 3 rRNA genes. The Sanger sequencing and Oxford Nanopore sequencing confirmed a pair of direct repeats had mediated genome recombination, resulting in the formation of two conformations. The gene conversation between plastome and mitochondrial genome was also observed in <em>S. tsinyunensis</em> by detecting gene migration, including six tRNA genes (namely, <em>trn</em>W-CCA, <em>trn</em>I-CAU, <em>trn</em>H-UUU, <em>trn</em>D-GUC, <em>trn</em>N-GUU, and <em>trn</em>M-CAU), five protein-coding gene fragments, and the fragments from 2 rRNA genes. Moreover, the dN/dS analysis revealed the <em>atp</em>9 gene had undergone strong negative selection, and four genes(<em>atp</em>4, <em>mtt</em>B, <em>ccm</em>Fc, and <em>ccm</em>B) probably had undergone positive selection during evolution in Lamiales. This work reported the first mitochondrial genome of <em>S. tsinyunensis</em>, which could be used as a reference genome for the important medicinal plants of the genus <em>Scutellaria</em>, and also provide much-desired information for molecular breeding.",
          //   images: [
          //     require("../images/article0/Fig1.webp"),
          //     require("../images/article0/Fig2.png"),
          //     require("../images/article0/Fig3.webp"),
          //     require("../images/article0/Fig4.png"),
          //     require("../images/article0/Fig5.webp"),
          //     require("../images/article0/Fig6.webp"),
          //     require("../images/article0/Fig7.webp"),
          //     require("../images/article0/Fig8.webp"),
          //   ],
          //   url: "https://doi.org/10.1007/s00425-021-03684-3",
          // },
          // {
          //   id: 1,
          //   title:
          //     "Assembly and comparative analysis of the complete multichromosomal mitochondrial genome of <em>Cymbidium ensifolium</em>, an orchid of high economic and ornamental value",
          //   author:
          //     "Baoming Shen, Airong Shen, Lina Liu, Yun Tan, Sainan Li & Zhuming Tan",
          //   abstract:
          //     "<strong>Background</strong><br> Orchidaceae is one of the largest groups of angiosperms, and most species have high economic value and scientific research value due to their ornamental and medicinal properties. In China, Chinese <em>Cymbidium</em> is a popular ornamental orchid with high economic value and a long history. However, to date, no detailed information on the mitochondrial genome of any species of Chinese <em>Cymbidium</em> has been published.<br><strong>Results</strong><br> Here, we present the complete assembly and annotation of the mitochondrial genome of <em>Cymbidium ensifolium</em> (L.) Sw. The mitogenome of <em>C. ensifolium</em> was 560,647 bp in length and consisted of 19 circular subgenomes ranging in size from 21,995 bp to 48,212 bp. The genome encoded 35 protein-coding genes, 36 tRNAs, 3 rRNAs, and 3405 ORFs. Repeat sequence analysis and prediction of RNA editing sites revealed a total of 915 dispersed repeats, 162 simple repeats, 45 tandem repeats, and 530 RNA editing sites. Analysis of codon usage showed a preference for codons ending in A/T. Interorganellar DNA transfer was identified in 13 of the 19 chromosomes, with plastidderived DNA fragments representing 6.81% of the <em>C. ensifolium</em> mitochondrial genome. The homologous fragments of the mitochondrial genome and nuclear genome were also analysed. Comparative analysis showed that the GC content was conserved, but the size, structure, and gene content of the mitogenomes varied greatly among plants with multichromosomal mitogenome structure. Phylogenetic analysis based on the mitogenomes reflected the evolutionary and taxonomic statuses of <em>C. ensifolium</em>. Interestingly, compared with the mitogenomes of <em>Cymbidium lancifolium</em> Hook. and <em>Cymbidium macrorhizon</em> Lindl., the mitogenome of <em>C. ensifolium</em> lost 8 ribosomal protein-coding genes.<br><strong>Conclusion</strong><br> In this study, we assembled and annotated the mitogenome of <em>C. ensifolium</em> and compared it with the mitogenomes of other Liliidae and plants with multichromosomal mitogenome structures. Our findings enrich the mitochondrial genome database of orchid plants and reveal the rapid structural evolution of <em>Cymbidium</em> mitochondrial genomes, highlighting the potential for mitochondrial genes to help decipher plant evolutionary history.",
          //   images: [
          //     require("../images/article1/Fig1.webp"),
          //     require("../images/article1/Fig2.webp"),
          //     require("../images/article1/Fig3.webp"),
          //     require("../images/article1/Fig4.webp"),
          //     require("../images/article1/Fig5.webp"),
          //     require("../images/article1/Fig6.webp"),
          //     require("../images/article1/Fig7.webp"),
          //     require("../images/article1/Fig8.webp"),
          //     require("../images/article1/Fig9.webp"),
          //     require("../images/article1/Fig10.webp"),
          //     require("../images/article1/Fig11.webp"),
          //     require("../images/article1/Fig12.webp"),
          //     require("../images/article1/Fig13.webp"),


          //   ],
          //   url: "https://doi.org/10.1186/s12870-024-04962-4",
          // },
          // {
          //   id: 2,
          //   title:
          //     "Curing cytoplasmic male sterility via TALEN-mediated mitochondrial genome editing",
          //   author:
          //     "Tomohiko Kazama, Miki Okuno, Yuta Watari, Shungo Yanase, Chie Koizuka, Yu Tsuruta, Hajime Sugaya, Atsushi Toyoda, Takehiko Itoh, Nobuhiro Tsutsumi, Kinya Toriyama, Nobuya Koizuka & Shin-ichi Arimura",
          //   abstract:
          //     "Sequence-specific nucleases are commonly used to modify the nuclear genome of plants. However, targeted modification of the mitochondrial genome of land plants has not yet been achieved. In plants, a type of male sterility called cytoplasmic male sterility (CMS) has been attributed to certain mitochondrial genes, but none of these genes has been validated by direct mitochondrial gene-targeted modification. Here, we knocked out CMS-associated genes (<em>orf</em>79 and <em>orf</em>125) of CMS varieties of rice and rapeseed, respectively, using transcription activator-like effector nucleases (TALENs) with mitochondria localization signals (mitoTALENs). We demonstrate that knocking out these genes cures male sterility, strongly suggesting that these genes are causes of CMS. Sequencing revealed that double-strand breaks induced by mitoTALENs were repaired by homologous recombination, and that during this process, the target genes and surrounding sequences were deleted. Our results show that mitoTALENs can be used to stably and heritably modify the mitochondrial genome in plants.",
          //   images: [
          //     require("../images/article2/Fig1.webp"),
          //     require("../images/article2/Fig2.webp"),
          //     require("../images/article2/Fig3.webp"),
          //     require("../images/article2/Fig4.webp"),
          //     require("../images/article2/Fig5.png"),
          //     require("../images/article2/Fig6.webp"),
          //     require("../images/article2/Fig7.webp"),
          //   ],
          //   url: "https://doi.org/10.1038/s41477-019-0459-z",
          // },
          // {
          //   id: 3,
          //   title:
          //     "Plant Mitochondrial Genomes: Dynamics and Mechanisms of Mutation",
          //   author:
          //     "José M. Gualberto<sup>1</sup> and Kathleen J. Newton<sup>2</sup>",
          //   abstract:
          //     "The large mitochondrial genomes of angiosperms are unusually dynamic because of recombination activities involving repeated sequences. These activities generate subgenomic forms and extensive genomic variation even within the same species. Such changes in genome structure are responsible for the rapid evolution of plant mitochondrial DNA and for the variants associated with cytoplasmic male sterility and abnormal growth phenotypes. Nuclear genes modulate these processes, and over the past decade, several of these genes have been identified. They are involved mainly in pathways of DNA repair by homologous recombination and mismatch repair, which appear to be essential for the faithful replication of the mitogenome. Mutations leading to the loss of any of these activities release error-prone repair pathways, resulting in increased ectopic recombination, genome instability, and heteroplasmy. We review the present state of knowledge of the genes and pathways underlying mitochondrial genome stability.",
          //   images: [
          //     require("../images/article3/Fig1.gif"),
          //     require("../images/article3/Fig2.gif"),
          //     require("../images/article3/Fig3.gif"),
          //     require("../images/article3/Fig4.gif"),
          //     require("../images/article3/Fig5.gif"),
          //     require("../images/article3/Fig6.gif"),
          //   ],
          //   url: "https://doi.org/10.1146/annurev-arplant-043015-112232",
          // },
          // 可以继续添加更多的论文信息
          // {
          //   id: 0,
          //   title:
          //     "PMAT2: An efficient graphical assembly toolkit for comprehensive organellar genomes",
          //   author:
          //     "Fuchuan Han, Changwei Bi, Yicun Chen, Xiaogang Dai, Zefu Wang, Huaitong Wu, Ning Sun, Yanshu Qu, Yang Yang, Yangdong Wang, Tongming Yin",
          //   graphical_abstract:
          //     "We developed PMAT2, an advanced toolkit for lineage-specific de novo assembly of plant, animal, and fungal mitochondrial genomes, as well as plant chloroplast genome. PMAT2 leverages optimized graph-based strategies tailored to organelle genome complexity, enabling complete and accurate assemblies, even with approximately 1 × highly accurate PacBio high-fidelity (HiFi) reads. By assembling 150 organellar genomes across diverse lineages, PMAT2 outperformed existing tools in assembly completeness. The source code for PMAT2 is publicly available at https://github.com/aiPGAB/PMAT2.",
          //   images: [
          //     require("../images/article0/PMAT2_1.png"),
          //     require("../images/article0/PMAT2_2.jpg"),
          //     require("../images/article0/PMAT2_3.jpg"),
          //   ],
          //   url: "https://doi.org/10.1002/imt2.70064",
          // },
          {
            id: 1,
            title:
              "PMAT: an efficient plant mitogenome assembly toolkit using low-coverage HiFi sequencing data",
            author:
              "Changwei Bi, Fei Shen, Fuchuan Han, Yanshu Qu, Jing Hou, Kewang Xu, Li-an Xu, Wenchuang He, Zhiqiang Wu, Tongming Yin",
            abstract:
              "Complete mitochondrial genomes (mitogenomes) of plants are valuable resources for nucleocytoplasmic interactions, plant evolution, and plant cytoplasmic male sterile line breeding. However, the complete assembly of plant mitogenomes is challenging due to frequent recombination events and horizontal gene transfers. Previous studies have adopted Illumina, PacBio, and Nanopore sequencing data to assemble plant mitogenomes, but the poor assembly completeness, low sequencing accuracy, and high cost limit the sampling capacity. Here, we present an efficient assembly toolkit (PMAT) for de novo assembly of plant mitogenomes using low-coverage HiFi sequencing data. PMAT has been applied to the de novo assembly of 13 broadly representative plant mitogenomes, outperforming existing organelle genome assemblers in terms of assembly accuracy and completeness. By evaluating the assembly of plant mitogenomes from different sequencing data, it was confirmed that PMAT only requires 1× HiFi sequencing data to obtain a complete plant mitogenome. The source code for PMAT is available at https://github.com/bichangwei/PMAT. The developed PMAT toolkit will indeed accelerate the understanding of evolutionary variation and breeding application of plant mitogenomes.",
            images: [
              require("../images/article1/PMAT_1.jpeg"),
              require("../images/article1/PMAT_2.jpeg"),
              require("../images/article1/PMAT_3.jpeg"),
              require("../images/article1/PMAT_4.jpeg"),
              require("../images/article1/PMAT_5.jpeg"),
              require("../images/article1/PMAT_6.jpeg"),


            ],
            url: "https://doi.org/10.1093/hr/uhae023",
          },
          {
            id: 2,
            title:
              "Plant organellar genomes: much done, much more to do",
            author:
              "Jie Wang, Shenglong Kan, Xuezhu Liao, Jiawei Zhou, Luke R. Tembrock, Henry Daniell, Shuangxia Jin, Zhiqiang Wu",
            abstract:
              "Plastids and mitochondria are the only organelles that possess genomes of endosymbiotic origin. In recent decades, advances in sequencing technologies have contributed to a meteoric rise in the number of published organellar genomes, and have revealed greatly divergent evolutionary trajectories. In this review, we quantify the abundance and distribution of sequenced plant organellar genomes across the plant tree of life. We compare numerous genomic features between the two organellar genomes, with an emphasis on evolutionary trajectories, transfers, the current state of organellar genome editing by transcriptional activator-like effector nucleases (TALENs), transcription activator-like effector (TALE)-mediated deaminase, and clustered regularly interspaced short palindromic repeats (CRISPR)/CRISPR-associated protein (Cas), as well as genetic transformation. Finally, we propose future research to understand these different evolutionary trajectories, and genome-editing strategies to promote functional studies and eventually improve organellar genomes.",
            images: [
              require("../images/article2/plant_1.jpg"),
              require("../images/article2/plant_2.jpg"),
              require("../images/article2/plant_3.jpg"),  
              require("../images/article2/plant_4.jpg"),  
            ],
            url: "https://doi.org/10.1016/j.tplants.2023.12.014",
          },
          {
            id: 3,
            title:
              "Advance in the assembly of the plant mitochondrial genomes using high-throughput DNA sequencing data of total cellular DNAs",
            author:
              "Yang Ni, Jingling Li, Yihui Tan, Guoan Shen, Chang Liu",
            summary:
              "The assembly of plant mitochondrial genomes presents unique challenges due to difficulties in isolating mitochondrial DNA (mtDNA) and plant mitochondrial genome characteristics, such as low interspecific conservation; sequence sharing among mitochondrial, nuclear and plastid DNAs; and complex structural variations. Our laboratory has sequenced and assembled a dozen plant mitochondrial genomes, testing various strategies and identifying numerous assembly issues. This review compared the advanced methods and tools for plant mitochondrial genome assembly, categorizing assembly algorithms into three groups: (1) reference-based, (2) de novo and (3) iterative mapping and extension. The performance of 11 software tools used most frequently over the past 5 years (GetOrganelle, Velvet, NOVOPlasty, SOAPdenovo2, Canu, Flye, SMARTdenovo, PMAT, NextDenovo, SPAdes and Unicycler) and two newly developed tools (TIPPo and Oatk) was assessed. The evaluation metrics included the completeness, contiguity and correctness of the assembled plant mitochondrial genomes. SMARTdenovo, NextDenovo and Oatk demonstrated superior performance in terms of contiguity and completeness. GetOrganelle and Flye excelled in correctness. Key challenges in plant mitochondrial genome assembly, such as removing nuclear mitochondrial DNA (NUMT) and mitochondrial plastid DNA (NUPT) contamination and resolving intra-genomic repetitive regions, were discussed. A general strategy for plant mitochondrial genome assembly used in studies conducted in our laboratory was summarized. This review serves as a resource for those assembling plant mitochondrial genomes or developing plant mitochondrial genome assembly tools.",
            images: [
              require("../images/article3/pbi_1.jpg"),
              require("../images/article3/pbi_2.jpg"),
              require("../images/article3/pbi_3.jpg"),
              require("../images/article3/pbi_4.jpg"),
              require("../images/article3/pbi_5.jpg"),
              require("../images/article3/pbi_6.jpg"),
              require("../images/article3/pbi_7.jpg"),
            ],
            url: "https://doi.org/10.1111/pbi.70249",
          },
          // {
          //   id: 3,
          //   title:
          //     "PMGA: A plant mitochondrial genome annotator",
          //   author:
          //     "Jingling Li, Yang Ni, Qianqi Lu, Haimei Chen, Chang Liu",
          //   abstract:
          //     "",
          //   images: [
          //     require("../images/article3/plantc_1.jpg"),
          //   ],
          //   url: "https://doi.org/10.1016/j.xplc.2024.101191",
          // },
          
          
        ],
      searchActive: false,
      publicationList: [],
      input: "",
      animate: false,
      intervalId: null,
    };
  },
  created() {
    this.getPublicationList();
  },
  methods: {
    goToMorePage() {
      // 点击“more”按钮时跳转到查看更多页面的逻辑
      this.$router.push("/publication");
    },
    async getPublicationList() {
      try {
        // 调用获取信息的api请求 , 并解构出data, 重命名为res
        const { data: res } = await this.$axios.get(
          "/api/api.publication/list",
          {
            params: {
              page: 1,
              pageSize: 100,
              search: "",
              sort: "year",
              method: "DESC",
            },
          }
        );
        // 赋值
        this.publicationList = res.data.rows;
        this.startScroll();
      } catch (err) {
        console.log(err);
      }
    },
    changeActive() {
      if (this.searchActive == false) {
        this.searchActive = true;
        this.$nextTick(() => {
          this.$refs.inputRef.focus();
        });
      }
    },
    search() {
      this.$router.push({ name: "Publication" });
      sessionStorage.setItem("userInputPublicationHome", this.input);
    },
    scrollUp() {
      if (this.publicationList.length <= 5) return;
      this.animate = true;
      setTimeout(() => {
        this.publicationList.push(this.publicationList[0]);
        this.publicationList.shift();
        this.animate = false;
      }, 500);
    },
    startScroll() {
      if (!this.intervalId && this.publicationList.length > 5) {
        this.intervalId = setInterval(this.scrollUp, 3000);
      }
    },
    stopScroll() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
  },
  mounted() {
    this.changeActive();
  },
  beforeDestroy() {
    this.stopScroll();
  },
};
</script>
<style scoped>
.anim {
  transition: all 0.5s;
  margin-top: -60px !important;
}
.paper-list {
  width: 1340px;
  margin: auto;
  border-radius: 20px;
}
.paper-row {
  margin-bottom: 20px;
}
.horizontal-card {
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: none;
}
.paper-image {
  width: 90%;
  height: auto;
}
.paper-author {
  font-size: 14px;
  color: #333;
  margin: 10px 0;
}
.paper-abstract {
  font-size: 12px;
  color: #666;
}
.info {
  margin: 10px 20px;
}
.recent-list {
  width: 1300px;
  margin: 0 auto 50px auto;
}
.recent-item {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  padding: 0 20px;
}
.recent-content {
  /* recent内容的样式 */
}
.more-button {
  margin: 0px 10px 10px 1235px;
}
.time {
  float: right;
}
.title-related {
  width: 1300px;
  margin: auto;
  height: 70px;
}
.related-container {
  border: 2px solid #41817c;
  width: 1000px;
  margin: 10px auto;
  height: 50px;
  border-radius: 50px;
  display: flex;
  flex-wrap: wrap;
}
.related-container:hover {
  border: 2px solid #8eebe5;
  transition: all 0.3s;
}
.related-words {
  width: 200px;
  margin: 7px 0 7px 20px;
  padding: 7px;
  border-radius: 50px;
  background: #2980b9; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    rgb(41, 128, 185),
    rgb(109, 213, 250),
    rgb(255, 255, 255)
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    rgb(41, 128, 185),
    rgb(109, 213, 250),
    rgb(255, 255, 255)
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-weight: 600;
}
.related-words-number {
  margin: 6px 0 7px 20px;
  font-size: 25px;
  color: #3a8bc8;
}
.related-words-total {
  margin: 8px 0 7px 10px;
  padding: 7px 0;
  color: #C8C9CC;
}
.related-icon {
  position: relative;
  left: 3%;
  top: 20%;
}
.search {
  margin: auto 0;
  width: 600px;
  display: flex;
}
</style>